import { useEffect } from "react"

const useFormPersist = (
  { watch, setValue, togglePersist },
  { exclude = [], onDataRestored, validate = true, dirty = true } = {}
) => {
  const values = watch()
  const getStorage = () => window.localStorage

  useEffect(() => {
    const str = getStorage().getItem("formData")
    if (str) {
      const values = JSON.parse(str)
      const dataRestored = {}

      Object.keys(values).forEach((key) => {
        const shouldSet = !exclude.includes(key)
        if (shouldSet) {
          dataRestored[key] = values[key]
          setValue(key, values[key], {
            shouldValidate: validate,
            shouldDirty: dirty,
          })
        }
      })

      if (onDataRestored) {
        onDataRestored(dataRestored)
      }
    }

    if (!togglePersist) {
      getStorage().removeItem("formData")
      return
    }
  }, ["formData", togglePersist])

  useEffect(() => {
    if (togglePersist) {
      getStorage().setItem("formData", JSON.stringify(values))
    }
  })
}

export default useFormPersist
